"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var PresetFilterType = {
  None: 0,
  TeamProfile: 1,
  HudlAccountProfile: 2
};

exports.default = PresetFilterType;